import { ReactNode } from "react";
import { CalendarFreezeContextProvider } from "./calendar-freeze-context";
import { CalendarScrollContextProvider } from "./calendar-scroll-context";
import { CalendarTimelineContextProvider } from "./calendar-timeline-context/CalendarTimelineContextProvider";

type Props = { children: NonNullable<ReactNode> };

const CalendarContextProvider = ({ children }: Props) => (
  <CalendarFreezeContextProvider>
    <CalendarScrollContextProvider>
      <CalendarTimelineContextProvider>
        {children}
      </CalendarTimelineContextProvider>
    </CalendarScrollContextProvider>
  </CalendarFreezeContextProvider>
);

export default CalendarContextProvider;
